import axios, { AxiosError, HttpStatusCode } from 'axios';
import { GraphQLFormattedError } from 'graphql/error';

import { registerListener } from '../../../../../../graphql/apolloErrorLink';

type Callback = (error: AxiosError | GraphQLFormattedError) => void;
const graphqlErrorHandler =
  (callback: Callback) => (error: GraphQLFormattedError) => {
    if (error.extensions?.code === 'graphql-authorization') callback(error);
  };

const axiosErrorHandler = (callback: Callback) => (error: AxiosError) => {
  if (
    error.response?.status.toString() === HttpStatusCode.Unauthorized.toString()
  ) {
    callback(error);
    return;
  }
  throw error;
};

export const authFailedRequestsInterceptor = (callback: Callback) => {
  // Handle failed graphql requests
  registerListener(graphqlErrorHandler(callback));
  // Handle failed axios requests
  axios.interceptors.response.use(null, axiosErrorHandler(callback));
};
